import AllTabsSummary from './AllTabsSummary'
import TabSummary from './TabSummary'
import {Component, React, observer, resolveCss} from '$src/handy'
import * as css from './ComparableSalesPage.css'
import PageLayout from '$src/common/PageLayout/PageLayout'
import 'react-table/react-table.css'
import {withRouter, RouteComponentProps, Redirect, Link} from 'react-router-dom'
import Left from './Left'
import {
  ResearchState,
  ResearchStateTab,
  HousingCorporation,
} from '$src/bootstrap/Store'
import Tabs from './Tabs'
import TableOfComparableSales from './TableOfComparableSales'
import TableOfRentData from './TableOfRentData'
import GenericButton from '$src/common/GenericButton'
import TheMap, {Point} from '$src/housingCorporations/TheMap'
import {getSnapshot} from 'mobx-state-tree'
import MapIcon from 'react-icons/lib/fa/map'
import MapOIcon from 'react-icons/lib/fa/map-o'
import ArrowLeftIcon from 'react-icons/lib/fa/arrow-left'
import CommentButton from '$src/comparableSales/CommentButton'
import AddressButton from '$src/comparableSales/AddressButton'
import {map} from 'lodash'
import FreezeStateButton from './FreezeStateButton'
import deepEqual from 'deep-equal'
import CustomScrollbar from '$src/common/CustomScrollbar'
import {createRef} from 'react'
import loadResearchState from './loadResearchState'
import PriceSwitch from './PriceSwitch'
import exportTransactionsToSpreadsheet from './exportTransactionsToSpreadsheet'

const classes = resolveCss(css)

type ThisTabOrAllTabs = 'thisTab' | 'allTabs'

interface State {
  loading: boolean
  error: undefined | string
  loaded: boolean
  hoveredItemIds: {[id: number]: true}
  activeItemIds: {[id: number]: true}
  activeItemIdsArrayPremise: any[]
  activeItemIdsArrayRent: any[]
  activeItemIdsArrayOldData: any[]
  mapOpen: boolean
  allTabsSummaryOpen: boolean
  whichSummaryIsShown: ThisTabOrAllTabs
  exporting: boolean
  rentTabActive: boolean
  displayRentData: boolean
  usingOldData: boolean
}

interface Props extends RouteComponentProps<any> {}

// @ts-ignore
@withRouter
@observer
export default class ComparableSalesPage extends Component<Props, State> {
  rightRef = createRef<HTMLDivElement>()
  constructor(props: Props, context: any) {
    super(props, context)
    this.state = {
      loading: false,
      error: undefined,
      loaded: false,
      hoveredItemIds: {},
      activeItemIds: {},
      activeItemIdsArrayPremise: [],
      activeItemIdsArrayRent: [],
      activeItemIdsArrayOldData: [],
      mapOpen: true,
      allTabsSummaryOpen: false,
      whichSummaryIsShown: 'allTabs',
      exporting: false,
      rentTabActive: false,
      displayRentData: false,
      usingOldData: false,
    }
  }

  UNSAFE_componentWillMount() {
    if (this.state.loaded === false) this.loadResearchState()
  }

  getHousingCorporationId(props: Props = this.props) {
    return props.match.params.housingCorporationId
  }

  getResearchState(props: Props = this.props): typeof ResearchState.Type {
    return this.store.researchStates.byHousingCorporationId.get(
      this.getHousingCorporationId(props),
    ) as any
  }

  getProjectId() {
    return this.props.match.params.projectId
  }

  getProjectName(props: Props = this.props) {
    return props.match.params.projectName
  }

  loadResearchState = async () => {
    this.setState(() => ({loading: true, error: undefined, loaded: false}))
    try {
      await loadResearchState(
        this,
        this.getHousingCorporationId(),
        this.getProjectId(),
      )
    } catch (e) {
      this.setState(() => ({
        loading: false,
        loaded: false,
        error: e.message,
      }))
    }
    this.setState({loading: false})
  }

  getActiveTabId(props: Props = this.props): string {
    const tabs = this.getResearchState(props).tabs
    const t = props.match.params.tabId
    return t || tabs.list[0].id
  }

  getActiveTabState(props: Props = this.props): typeof ResearchStateTab.Type {
    return this.getResearchState(props).tabs.byId.get(
      this.getActiveTabId(props),
    ) as any
  }

  getHousingCorporation(): typeof HousingCorporation.Type {
    return this.store.housingCorporations.byId.get(
      this.getHousingCorporationId(),
    ) as any
  }

  getRentAndTransactionData(activeTabState: typeof ResearchStateTab.Type) {
    const foundItems = getSnapshot(activeTabState.foundItems)
    const {byId} = foundItems
    const listPremise = foundItems.list.map((id: string) => ({
      ...byId[id],
      selected: foundItems.selectedIds[id] === true,
    }))
    const listRent = foundItems.list.map((id: string) => ({
      ...byId[id],
      selected: foundItems.selectedIdsRent[id] === true,
    }))
    const listOldData = foundItems.list.map((id: string) => ({
      ...byId[id],
      selected: foundItems.selectedIdsOldData[id] === true,
    }))

    const premiseList = listPremise.filter(
      (item: {dataType: string}) => item.dataType === 'premise',
    )

    const rentList = listRent.filter(
      (item: {dataType: string}) => item.dataType === 'rent',
    )

    let oldData: any[] = []
    if (listOldData.filter((item: {dataType: string}) => !item.dataType)) {
      oldData = [
        ...listOldData.filter((item: {dataType: string}) => !item.dataType),
      ]
    }

    return {
      premiseList,
      rentList,
      oldData,
    }
  }

  render() {
    const {state} = this

    return (
      <PageLayout>
        {state.loading ? (
          <div className={css.loading}>Loading...</div>
        ) : state.error ? (
          <div className={css.error}>Error: {this.state.error}</div>
        ) : (
          this.renderLayout()
        )}
      </PageLayout>
    )
  }

  toggleMap = () => {
    this.setState({mapOpen: !this.state.mapOpen})
  }

  toggleRentTab = () => {
    this.setState({rentTabActive: !this.state.rentTabActive})
  }

  toggleRentData = () => {
    this.setState({displayRentData: !this.state.displayRentData})
  }

  clearFilteredItemsPremise = () => {
    this.setState({activeItemIdsArrayPremise: []})
  }

  clearFilteredItemsRent = () => {
    this.setState({activeItemIdsArrayRent: []})
  }

  clearFilteredItemsOldData = () => {
    this.setState({activeItemIdsArrayOldData: []})
  }

  private renderLayout(): React.ReactNode {
    const {state, props} = this

    const researchState = this.getResearchState()
    const activeTabState = this.getActiveTabState()
    const housingCorporation = this.getHousingCorporation()

    if (!researchState || !activeTabState) {
      return (
        <Redirect
          to={`/comparable-sales-list/${props.match.params.projectId}/${props.match.params.projectName}/${props.match.params.housingCorporationId}`}
        />
      )
    }

    const dd = this.store.hiddenColumnsInComparableSalesView
    const hiddenCols = getSnapshot(
      this.store.hiddenColumnsInComparableSalesView.byId,
    )

    const {premiseList, rentList, oldData} = this.getRentAndTransactionData(
      activeTabState,
    )

    const numberOfFoundPremiseItems = premiseList.length
    const numberOfFoundRentItems = rentList.length
    const numberOfFoundOlderItems = oldData.length

    const numberOfSelectedIdsPremise =
      activeTabState.foundItems.selectedIds.size
    const numberOfSelectedIdsRent =
      activeTabState.foundItems.selectedIdsRent.size
    const numberOfSelectedIdsOlderData =
      activeTabState.foundItems.selectedIdsOldData.size

    if (numberOfFoundOlderItems > 0 && !this.state.usingOldData) {
      this.setState({usingOldData: true})
    }

    let frozen = false

    if (this.getHousingCorporation().isFrozen()) {
      frozen = this.getHousingCorporation().isFrozen()
    }

    return (
      <div className={css.layout}>
        {this.renderMap()}

        <div className={css.top}>
          <Link
            to={`/housing-corporations-list/${this.getProjectId()}/${this.getProjectName()}`}
            className={css.backLink}
          >
            <ArrowLeftIcon />
          </Link>
          <a className={css.topInfo} title={housingCorporation.address}>
            {housingCorporation.name}
          </a>
          <div className={css.tabs}>
            <Tabs
              housingCorporationId={this.getHousingCorporationId()}
              housingCorporation={this.getHousingCorporation()}
              activeTabId={props.match.params.tabId}
              tabs={researchState.tabs}
              projectId={props.match.params.projectId}
              projectName={props.match.params.projectName}
              frozen={frozen}
            />
          </div>
          <div className={css.buttons}>
            <AddressButton housingCorporation={this.getHousingCorporation()} />
            <FreezeStateButton
              housingCorporation={this.getHousingCorporation()}
            />
            <CommentButton housingCorporation={this.getHousingCorporation()} />
            <GenericButton
              variant="round"
              withMargin
              css={{container: css.button}}
              onClick={this.toggleMap}
            >
              {state.mapOpen ? <MapIcon /> : <MapOIcon />}
            </GenericButton>
            <div className={css.aboveTheMap}>
              <GenericButton
                css={{container: css.exportButton}}
                variant="round"
                disabled={this.state.exporting}
                onClick={() => {
                  if (this.state.exporting) return
                  this.export()
                }}
              >
                Export
              </GenericButton>
            </div>
          </div>
        </div>
        <div className={css.body}>
          <div className={css.left}>
            <Left
              activeTabState={activeTabState}
              frozen={frozen}
              toggleRentTab={this.toggleRentTab}
              rentTabState={this.state.rentTabActive}
              premiseData={premiseList}
              rentData={rentList}
            />
          </div>
          {this.state.rentTabActive ? (
            <div className={css.right} ref={this.rightRef}>
              <CustomScrollbar refToScrollableEl={this.rightRef} />
              <div className={css.hiddenCols}>
                <a
                  className={
                    css.selectAll +
                    ' ' +
                    (numberOfSelectedIdsRent === 0
                      ? css.willSelectAll
                      : css.willDeselectAll) +
                    ' ' +
                    (frozen ? css.frozen : '')
                  }
                  onClick={() =>
                    this.selectOrDeselectAllRent(numberOfSelectedIdsRent === 0)
                  }
                >
                  {numberOfSelectedIdsRent}/{numberOfFoundRentItems}
                  {numberOfSelectedIdsRent === 0
                    ? ' – Select All'
                    : ' – Deselect All'}
                </a>
                {map(hiddenCols, (_, id) => {
                  const onClick = () => {
                    dd.remove(id)
                  }
                  return (
                    <div
                      className={css.hiddenCol}
                      key={`hiddenCol-${id}`}
                      onClick={onClick}
                    >
                      {id}
                    </div>
                  )
                })}
                <GenericButton
                  variant="smallRound"
                  withMargin
                  css={{container: css.button}}
                  onClick={this.clearFilteredItemsRent}
                  disabled={
                    this.state.activeItemIdsArrayRent.length > 0 ? false : true
                  }
                  style={{
                    color:
                      this.state.activeItemIdsArrayRent.length > 0
                        ? '#C6167F'
                        : '#86949f',
                  }}
                >
                  Clear map selection
                </GenericButton>
              </div>
              <div className={css.table}>
                <TableOfRentData
                  activeTabState={activeTabState}
                  activeItemIds={this.state.activeItemIds}
                  hoveredItemIds={this.state.hoveredItemIds}
                  setHoveredItemIds={this.setHoveredItemIds}
                  setActiveItemIds={this.setActiveItemIds}
                  activeItemIdsArray={this.state.activeItemIdsArrayRent}
                />
                <div className={state.mapOpen ? css.mapSpaceFiller : ''} />
              </div>
            </div>
          ) : numberOfFoundOlderItems > 0 ? (
            <div className={css.right} ref={this.rightRef}>
              <CustomScrollbar refToScrollableEl={this.rightRef} />
              <div className={css.hiddenCols}>
                <a
                  className={
                    css.selectAll +
                    ' ' +
                    (numberOfSelectedIdsOlderData === 0
                      ? css.willSelectAll
                      : css.willDeselectAll) +
                    ' ' +
                    (frozen ? css.frozen : '')
                  }
                  onClick={() =>
                    this.selectOrDeselectAllOldData(
                      numberOfSelectedIdsOlderData === 0,
                    )
                  }
                >
                  {numberOfSelectedIdsOlderData}/{numberOfFoundOlderItems}
                  {numberOfSelectedIdsOlderData === 0
                    ? ' – Select All'
                    : ' – Deselect All'}
                </a>
                {map(hiddenCols, (_, id) => {
                  const onClick = () => {
                    dd.remove(id)
                  }
                  return (
                    <div
                      className={css.hiddenCol}
                      key={`hiddenCol-${id}`}
                      onClick={onClick}
                    >
                      {id}
                    </div>
                  )
                })}

                <GenericButton
                  variant="smallRound"
                  withMargin
                  css={{container: css.button}}
                  onClick={this.clearFilteredItemsOldData}
                  disabled={
                    this.state.activeItemIdsArrayOldData.length > 0
                      ? false
                      : true
                  }
                  style={{
                    color:
                      this.state.activeItemIdsArrayOldData.length > 0
                        ? '#C6167F'
                        : '#86949f',
                  }}
                >
                  Clear map selection
                </GenericButton>
              </div>
              <div className={css.table}>
                <TableOfComparableSales
                  activeTabState={activeTabState}
                  activeItemIds={this.state.activeItemIds}
                  hoveredItemIds={this.state.hoveredItemIds}
                  setHoveredItemIds={this.setHoveredItemIds}
                  setActiveItemIds={this.setActiveItemIds}
                  researchState={this.getResearchState()}
                  housingCorporation={this.getHousingCorporation()}
                  activeItemIdsArray={this.state.activeItemIdsArrayOldData}
                  dataType="oldData"
                />
                <div className={state.mapOpen ? css.mapSpaceFiller : ''} />
              </div>
            </div>
          ) : (
            <div className={css.right} ref={this.rightRef}>
              <CustomScrollbar refToScrollableEl={this.rightRef} />
              <div className={css.hiddenCols}>
                <a
                  className={
                    css.selectAll +
                    ' ' +
                    (numberOfSelectedIdsPremise === 0
                      ? css.willSelectAll
                      : css.willDeselectAll) +
                    ' ' +
                    (frozen ? css.frozen : '')
                  }
                  onClick={() =>
                    this.selectOrDeselectAll(numberOfSelectedIdsPremise === 0)
                  }
                >
                  {numberOfSelectedIdsPremise}/{numberOfFoundPremiseItems}
                  {numberOfSelectedIdsPremise === 0
                    ? ' – Select All'
                    : ' – Deselect All'}
                </a>
                {map(hiddenCols, (_, id) => {
                  const onClick = () => {
                    dd.remove(id)
                  }
                  return (
                    <div
                      className={css.hiddenCol}
                      key={`hiddenCol-${id}`}
                      onClick={onClick}
                    >
                      {id}
                    </div>
                  )
                })}

                <GenericButton
                  variant="smallRound"
                  withMargin
                  css={{container: css.button}}
                  onClick={this.clearFilteredItemsPremise}
                  disabled={
                    this.state.activeItemIdsArrayPremise.length > 0
                      ? false
                      : true
                  }
                  style={{
                    color:
                      this.state.activeItemIdsArrayPremise.length > 0
                        ? '#C6167F'
                        : '#86949f',
                  }}
                >
                  Clear map selection
                </GenericButton>
              </div>
              <div className={css.table}>
                <TableOfComparableSales
                  activeTabState={activeTabState}
                  activeItemIds={this.state.activeItemIds}
                  hoveredItemIds={this.state.hoveredItemIds}
                  setHoveredItemIds={this.setHoveredItemIds}
                  setActiveItemIds={this.setActiveItemIds}
                  activePremiseState={this.state.premiseDataActive}
                  researchState={this.getResearchState()}
                  housingCorporation={this.getHousingCorporation()}
                  activeItemIdsArray={this.state.activeItemIdsArrayPremise}
                  dataType="premise"
                />
                <div className={state.mapOpen ? css.mapSpaceFiller : ''} />
              </div>
            </div>
          )}
        </div>
        {this.state.allTabsSummaryOpen && (
          <CustomScrollbar refToScrollableEl={this.rightRef} aboveSummary />
        )}
        <div {...classes('allTabsSummary', state.allTabsSummaryOpen && 'open')}>
          <div {...classes('summaryHeaderContainer')}>
            <div
              {...classes('summaryHeader')}
              onClick={this.openAllTabsSummary}
            >
              <SummaryLink
                which="thisTab"
                current={this.state.whichSummaryIsShown}
                onActive={this._changeActiveSummaryTab}
              />
              <SummaryLink
                which="allTabs"
                current={this.state.whichSummaryIsShown}
                onActive={this._changeActiveSummaryTab}
              />
            </div>
            {this.state.allTabsSummaryOpen &&
              (this.state.rentTabActive ? (
                <button
                  {...classes('closeBtn')}
                  onClick={this.closeAllTabsSummary}
                >
                  Close
                </button>
              ) : (
                <>
                  <PriceSwitch
                    housingCorporation={this.getHousingCorporation()}
                  />
                  <button
                    {...classes('closeBtn')}
                    onClick={this.closeAllTabsSummary}
                  >
                    Close
                  </button>
                </>
              ))}
          </div>
          {this.state.whichSummaryIsShown === 'thisTab' ? (
            <TabSummary
              activeTabState={activeTabState}
              housingCorporation={this.getHousingCorporation()}
              toggleRentData={this.toggleRentData}
              rentTabState={this.state.rentTabActive}
            />
          ) : (
            <AllTabsSummary
              researchState={this.getResearchState()}
              housingCorporation={this.getHousingCorporation()}
              toggleRentData={this.toggleRentData}
              rentTabState={this.state.rentTabActive}
            />
          )}
        </div>
      </div>
    )
  }

  async export() {
    this.setState({exporting: true})
    await exportTransactionsToSpreadsheet(
      this,
      this.getProjectId(),
      this.getHousingCorporationId(),
    )
    this.setState({exporting: false})
  }

  _changeActiveSummaryTab = (which: ThisTabOrAllTabs) => {
    this.setState({whichSummaryIsShown: which})
  }

  openAllTabsSummary = () => {
    this.setState({allTabsSummaryOpen: true})
  }

  closeAllTabsSummary = () => {
    this.setState({allTabsSummaryOpen: false})
  }

  setHoveredItemIds = (hoveredItemIds: {[id: number]: true}) => {
    if (deepEqual(this.state.hoveredItemIds, hoveredItemIds)) return
    this.setState({hoveredItemIds})
  }

  setActiveItemIds = (activeItemIds: {[id: number]: true}) => {
    this.setState({
      activeItemIds:
        this.state.activeItemIds === activeItemIds ? {} : activeItemIds,
    })

    if (
      this.state.activeItemIds === {} ||
      this.state.activeItemIds === activeItemIds
    ) {
      this.filterItems(this.state.activeItemIds)
    }
  }

  filterItems = (activeItemIds: {[id: number]: true}) => {
    const activeTabState = this.getActiveTabState()
    const {premiseList, rentList, oldData} = this.getRentAndTransactionData(
      activeTabState,
    )

    const activeItemIdsList = Object.keys(activeItemIds).map((item: any) => {
      return {id: item}
    })

    const premiseFilter = activeItemIdsList.filter(activeItem =>
      premiseList.some((premiseItem: any) => activeItem.id === premiseItem.id),
    )

    const rentFilter = activeItemIdsList.filter(activeItem =>
      rentList.some((rentItem: any) => activeItem.id === rentItem.id),
    )

    const oldDataFilter = activeItemIdsList.filter(activeItem =>
      oldData.some((oldDataItem: any) => activeItem.id === oldDataItem.id),
    )

    this.setState({
      activeItemIdsArrayPremise: premiseFilter,
      activeItemIdsArrayRent: rentFilter,
      activeItemIdsArrayOldData: oldDataFilter,
    })
  }

  selectOrDeselectAll = (shouldSelectAll: boolean) => {
    if (this.getHousingCorporation().isFrozen()) return
    const activeTabState = this.getActiveTabState()
    if (shouldSelectAll) {
      activeTabState.selectAll()
    } else {
      activeTabState.deselectAll()
    }
  }

  selectOrDeselectAllRent = (shouldSelectAll: boolean) => {
    if (this.getHousingCorporation().isFrozen()) return
    const activeTabState = this.getActiveTabState()
    if (shouldSelectAll) {
      activeTabState.selectAllRent()
    } else {
      activeTabState.deselectAllRent()
    }
  }

  selectOrDeselectAllOldData = (shouldSelectAll: boolean) => {
    if (this.getHousingCorporation().isFrozen()) return
    const activeTabState = this.getActiveTabState()
    if (shouldSelectAll) {
      activeTabState.selectAllOldData()
    } else {
      activeTabState.deselectAllOldData()
    }
  }

  renderMap(): React.ReactNode {
    return (
      <Map
        mapOpen={this.state.mapOpen}
        activeTabState={this.getActiveTabState()}
        housingCorporation={this.getHousingCorporation()}
        activeItemIds={this.state.activeItemIds}
        hoveredItemIds={this.state.hoveredItemIds}
        setHoveredItemIds={this.setHoveredItemIds}
        setActiveItemIds={this.setActiveItemIds}
        rentTabActive={this.state.rentTabActive}
        usingOldData={this.state.usingOldData}
      />
    )
  }
}

const SummaryLink = (props: {
  which: ThisTabOrAllTabs
  current: ThisTabOrAllTabs
  onActive: (which: ThisTabOrAllTabs) => void
}) => {
  return (
    <div
      {...classes('summaryLink', props.which === props.current && 'active')}
      onClick={() => props.onActive(props.which)}
    >
      {props.which === 'thisTab' ? 'Tab Summary' : 'Overall Summary'}
    </div>
  )
}

const Map = observer(
  (props: {
    mapOpen: boolean
    activeTabState: typeof ResearchStateTab.Type
    housingCorporation: typeof HousingCorporation.Type
    activeItemIds: {[id: number]: true}
    hoveredItemIds: {[id: number]: true}
    setHoveredItemIds: Function
    setActiveItemIds: (ids: {[id: number]: true}) => void
    rentTabActive: boolean
    usingOldData?: boolean
  }): React.ReactNode => {
    if (!props.mapOpen) return []

    const activeTabState = props.activeTabState
    const {foundItems} = activeTabState
    const byId = getSnapshot(foundItems.byId)
    const markers = foundItems.list
      .map(id => ({...byId[id], _id: id}))
      .filter(
        ({location: {lat, long}}: {location: {lat: number; long: number}}) =>
          !isNaN(lat) &&
          !isNaN(long) &&
          typeof lat === 'number' &&
          typeof long === 'number' &&
          lat !== 0 &&
          long !== 0,
      )

    const premiseMarkers = markers.filter(
      (item: any) => item.dataType === 'premise',
    )
    const rentMarkers = markers.filter((item: any) => item.dataType === 'rent')
    let oldDataMarkers: any[] = []
    if (markers.filter((item: any) => !item.dataType)) {
      oldDataMarkers = [...markers.filter((item: any) => !item.dataType)]
    }

    const drawingState: any = activeTabState.query.mapShape
    const drawingStateRent: any = activeTabState.query.mapShapeRent
    const housingCorporation = props.housingCorporation
    const blueMarkerLocation: Point = getSnapshot(housingCorporation.location)
    const selectedIds = getSnapshot(foundItems.selectedIds)
    const selectedIdsRent = getSnapshot(foundItems.selectedIdsRent)
    const selectedIdsOldData = getSnapshot(foundItems.selectedIdsOldData)

    return (
      <div className={css.map + ' ' + (!props.mapOpen && css.mapHidden)}>
        {props.rentTabActive ? (
          <TheMap
            markers={rentMarkers}
            activeItemIds={props.activeItemIds}
            hoveredItemIds={props.hoveredItemIds}
            setHoveredItemIds={props.setHoveredItemIds}
            setActiveItemIds={props.setActiveItemIds}
            blueMarkerLocation={blueMarkerLocation}
            withResizer={true}
            withDrawings={true}
            shape={drawingStateRent}
            setShape={(s: any) => {
              activeTabState.setMapShapeRent(s)
            }}
            selectedItemIds={selectedIdsRent}
            highlightSelectedItems={true}
            shapeEditable={!housingCorporation.isFrozen()}
          />
        ) : props.usingOldData ? (
          <TheMap
            markers={oldDataMarkers}
            activeItemIds={props.activeItemIds}
            hoveredItemIds={props.hoveredItemIds}
            setHoveredItemIds={props.setHoveredItemIds}
            setActiveItemIds={props.setActiveItemIds}
            blueMarkerLocation={blueMarkerLocation}
            withResizer={true}
            withDrawings={true}
            shape={drawingState}
            setShape={(s: any) => {
              activeTabState.setMapShape(s)
            }}
            selectedItemIds={selectedIdsOldData}
            highlightSelectedItems={true}
            shapeEditable={!housingCorporation.isFrozen()}
          />
        ) : (
          <TheMap
            markers={premiseMarkers}
            activeItemIds={props.activeItemIds}
            hoveredItemIds={props.hoveredItemIds}
            setHoveredItemIds={props.setHoveredItemIds}
            setActiveItemIds={props.setActiveItemIds}
            blueMarkerLocation={blueMarkerLocation}
            withResizer={true}
            withDrawings={true}
            shape={drawingState}
            setShape={(s: any) => {
              activeTabState.setMapShape(s)
            }}
            selectedItemIds={selectedIds}
            highlightSelectedItems={true}
            shapeEditable={!housingCorporation.isFrozen()}
          />
        )}
      </div>
    )
  },
)



// WEBPACK FOOTER //
// ./src/comparableSales/ComparableSalesPage.tsx